import { BrowserRouter as Router, Route } from "react-router-dom";

import CustomSwitch from "./components/custom-switch";

//Custom Theme
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";

//Pages
import { LoginPage, DashboardUsers, DashboardUserDetails } from './pages'

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <CustomSwitch>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard/users" element={<DashboardUsers />} />
          <Route path="/dashboard/users/details" element={<DashboardUserDetails />} />
        </CustomSwitch>
      </Router>
    </ThemeProvider>
  );
}

export default App;
